// extracted by mini-css-extract-plugin
module.exports = {"containerDesktop":"FAQFreshdesk_containerDesktop__sw7Q_","containerMobile":"FAQFreshdesk_containerMobile___c3Ww","faq":"FAQFreshdesk_faq__M9fYE"};